// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"793d93cf","223":"966a9ccb","239":"02175cfa","455":"9f7cb069"}[chunkId] + ".chunk.js";
};